
import { Component, Vue } from 'vue-property-decorator'
import container from '@/components/moyo/container.vue'
import heading from '@/components/moyo/heading.vue'

@Component({
  name: 'EducationProgramKenya',
  components: { container, heading },
})
export default class EducationProgramKenya extends Vue {}
